import { ChiptaElement, html, css } from 'chipta-libs/main.js';

class LayoutConcave extends ChiptaElement {

  render() {
    return html`
      <div id="outer-container">
        <div id="inner-container">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1651 45"
              preserveAspectRatio="none"
          >
            <path d="M1651 0.372864C1447.51 15.4465 1154.15 24.908 828 24.908C499.173 24.908 203.667 15.2904 0 0V44.908H1651V0.372864Z" fill="white"/>
          </svg>
        </div>
      </div>
    `;
  }


  static get styles() {
    return css`

      :host {
        display: block;
      }

      #outer-container {
        position: relative;
      }

      #inner-container {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: 100%;
        height: 10px;
        top: -9px;
      }

      svg {
        width: 100%;
      }

    `;
  }
}

customElements.define('layout-concave', LayoutConcave);
